import { Box, Flex } from "@chakra-ui/react";
import React, { useState } from "react";
import MeetingControls from "./MeetingControls";
import JoinMeetingPopup from "./JoinMeetingPopup";
import { MeetingAttendeesList } from "./MeetingAttendeesList";
import VideoCallUserCard from "./VideoCallUserCard";
import MeetingMessaging from "./meetingMessaging/MeetingMessaging";
import { fullScreenControlStyles, fullScreenStyles } from "./GroupMeeting";
import MobileBottomNavigation from "./MobileBottomNavigation";
import { AiOutlineFullscreen, AiOutlineFullscreenExit } from "react-icons/ai";

function OneOnOneMeeting() {
  const [showChat, setShowChat] = useState(false);
  const [fullScreen, setFullScreen] = useState(false);

  return (
    <Box w={["100%", "73%"]}>
      <Flex
        width="100%"
        flexDirection={"column"}
        justifyContent={"space-between"}
        height={"85vh"}
        {...(fullScreen
          ? { ...fullScreenStyles, pt: "10px", bg: "#f3f3f3" }
          : {})}
      >
        <MeetingMessaging
          showMessaging={showChat}
          setShowMessaging={setShowChat}
          position="absolute"
          top="23%"
          left="10px"
        />
        <Box
          width="100%"
          height={fullScreen ? "100%" : "100%"}
          borderRadius="10px"
          overflow={"hidden"}
          position={"relative"}
        >
          <Flex
            w="40px"
            h="40px"
            position={"absolute"}
            justifyContent="center"
            alignItems="center"
            borderRadius={"50%"}
            right="10px"
            onClick={() => setFullScreen((prev) => !prev)}
            cursor="pointer"
          >
            {fullScreen ? (
              <AiOutlineFullscreenExit color="#000" fontSize={"1.6em"} />
            ) : (
              <AiOutlineFullscreen color="#000" fontSize={"1.6em"} />
            )}
          </Flex>
          <Flex
            position={"absolute"}
            top={fullScreen ? "10%" : "10%"}
            left="0"
            right="0"
            flexDirection={["column", "row"]}
            gap="20px"
            {...(fullScreen ? { px: ["10px", "50px", "50px", "50px"] } : {})}
          >
            <VideoCallUserCard
              fullScreen={fullScreen}
              flex={["unset", "1"]}
              name="Peter Taylor"
              {...(fullScreen ? { h: ["300px", "500px"] } : { h: ["300px"] })}
            />
            <VideoCallUserCard
              fullScreen={fullScreen}
              userActive={true}
              flex={["unset", "1"]}
              name="Peter Taylor"
              {...(fullScreen ? { h: ["300px", "500px"] } : { h: ["300px"] })}
            />
          </Flex>
        </Box>
        <MeetingControls
          oneToOne
          {...(fullScreen ? fullScreenControlStyles : {})}
          fullScreen={fullScreen}
          setShowChat={setShowChat}
        />
      </Flex>
    </Box>

  );
}

export default OneOnOneMeeting;
